/* ============================================================
   YOLANDA — language

   The retired nano-story section kept its own setLang() and dictionary
   inline. More than one section needs the same behaviour, so it lives
   here once and each section registers its own strings into it.

   Sections call:
     YolandaI18n.register({ en: {...}, zh: {...} });

   Markup:
     <p data-i18n="key">English default</p>
     <a data-i18n="key" data-en="/x" data-zh="/x-zh">…</a>
     <input data-i18n-placeholder="key">
     <button data-lang="en">EN</button>

   The English string stays in the HTML as the default, so the page
   is readable and indexable before a single byte of JS runs.
   ============================================================ */
(function () {
  "use strict";

  /* Several sections -- and now the footer, on every page -- each include
     this file. A second copy would replace the registry with an empty one
     and bind a second click handler, so only the first copy runs. */
  if (window.YolandaI18n) return;

  var T = { en: {}, zh: {} };
  var KEY = "yolanda-lang";
  var current = "en";

  function register(dict) {
    ["en", "zh"].forEach(function (l) {
      if (!dict[l]) return;
      for (var k in dict[l]) if (Object.prototype.hasOwnProperty.call(dict[l], k)) T[l][k] = dict[l][k];
    });
    apply(current);
  }

  function apply(l) {
    if (l !== "en" && l !== "zh") l = "en";
    current = l;

    document.querySelectorAll("[data-i18n]").forEach(function (el) {
      var v = T[l][el.getAttribute("data-i18n")];
      if (v !== undefined) el.innerHTML = v;
      var href = el.getAttribute("data-" + l);
      if (href) el.setAttribute("href", href);
    });

    document.querySelectorAll("[data-i18n-placeholder]").forEach(function (el) {
      var v = T[l][el.getAttribute("data-i18n-placeholder")];
      if (v !== undefined) el.setAttribute("placeholder", v);
    });

    document.querySelectorAll("[data-i18n-label]").forEach(function (el) {
      var v = T[l][el.getAttribute("data-i18n-label")];
      if (v !== undefined) el.setAttribute("aria-label", v);
    });

    document.documentElement.lang = (l === "zh") ? "zh-Hans" : "en";
    document.body.classList.toggle("zh", l === "zh");

    document.querySelectorAll("[data-lang]").forEach(function (b) {
      var on = b.getAttribute("data-lang") === l;
      b.classList.toggle("on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });

    try { localStorage.setItem(KEY, l); } catch (e) {}
  }

  function init() {
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (!saved) {
      var nav = (navigator.language || "").toLowerCase();
      saved = (nav.indexOf("zh") === 0) ? "zh" : "en";
    }
    apply(saved);

    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-lang]");
      if (!b) return;
      e.preventDefault();
      apply(b.getAttribute("data-lang"));
    });
  }

  window.YolandaI18n = { register: register, set: apply, get: function () { return current; } };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
